import React from "react";
import { Route, Redirect } from "react-router-dom";

function PrivateRoute({
  component: Component,
  allowedRoles,
  role,
  isAuth,
  ...rest
}) {
  if (!isAuth || (allowedRoles && !allowedRoles.includes(role))) {
    return <Route render={(props) => <Redirect to="/auth/login" />} />;
  }

  return <Route {...rest} render={(props) => <Component {...props} />} />;
}

export default PrivateRoute;
